<template>
  <b-button disabled class="timer" variant="primary">
    残り{{ minutes > -1 ? `${minutes}` : ' ' }}分{{ seconds > -1 ? `${seconds}` : ' ' }}秒
  </b-button>
</template>
<script>
export default {
  data() {
    return {
      countDownTimer: null,
      examEndDate: null,
      minutes: -1,
      seconds: -1,
    };
  },
  created() {
    Promise.resolve()
      .then(() =>
        this.$axios.get('/api/exam/time'))
      .then((response) => {
        this.examEndDate = new Date(response.data.endTime);
      })
      .catch((e) => {
        // TODO: 時間が取得できなかったときの処理
        console.log(e);
      })
      .finally(() => {
        this.countDownTimer = setInterval(() => {
          let now = new Date();
          now = now.setHours(now.getHours());
          const diff = this.examEndDate - now;

          const hours =
                  Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes =
                  Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds =
                  Math.floor((diff % (1000 * 60)) / 1000);

          this.minutes = hours * 60 + minutes;
          this.seconds = seconds;

          if (this.minutes < 0) this.minutes = 0;
          if (this.seconds < 0) this.seconds = 0;

          if (diff < 0) {
            clearInterval(this.countDownTimer);
            this.$axios.post('/api/exam/close');
            window.location.href = '/exam/redirect_by_status';
          }
        }, 1000);
      });
  },
  destroyed() {
    clearInterval(this.countDownTimer);
  },
};
</script>

<style>
.timer {
  font-size: 10px;
  font-weight: bold;
  margin-right: 5px;
}
@media screen and (min-width: 950px) {
  .timer {
    font-size: 13px;
    font-weight: bold;
    margin-right: 10px;
  }
}
</style>
